module.exports = __webpack_public_path__ + "img/content3-2.6cb6649f.webp";